import { eventBus, EnumEventBus } from "../EventBus";
import { INITIAL_TRIANGLE_RADIANS, CIRCLE_RADIUS } from "../../types/Config";
import { Coord } from "../../../../../../src/types/Interface";
import { getTangentCoords } from "../../helpers/getTangentCoords";
import { generateRandomlyRadians } from "./helpers/pointHelpers";
import BasePointManager from "../../../../../../src/managers/BasePointManager";


export default class PointManager extends BasePointManager {
  tangent: Coord[] = [];
  sltdTPIndex = 0 // selected Tangent Point Index
  constructor(cCoord: Coord) {
    super(cCoord, CIRCLE_RADIUS, INITIAL_TRIANGLE_RADIANS)

    this.setCoord();
    this.draw();

    eventBus.on(EnumEventBus.genRndmTriangle, () => this.generateRandomShape())
    eventBus.on(EnumEventBus.moveTangentPoint, (v: number) => this.moveTangentPoint(v));
    eventBus.on(EnumEventBus.moveAllPoints, (v: number) => this.moveAllPoints(v));
    eventBus.on(EnumEventBus.setRefPoints, () => this.pointRefRadians = [...this.pointRadians]);
    eventBus.on(EnumEventBus.setSltdTPIndex, (index: number) => {
      this.sltdTPIndex = index;
      this.setCoord();
    })
  }
  setTangentCoords = () => {
    const tPointCoord = this.getRedPointsCoord()[this.sltdTPIndex];
    return getTangentCoords(this.cCoord, tPointCoord, 300);
  };
  getTangentCoords = () => this.setTangentCoords();

  getSltdTPointIndex = () => this.sltdTPIndex;
  generateRandomShape = () => generateRandomlyRadians(this);
  moveTangentPoint(v: number) {
    const tangentPoint = this.getRedPoints()[this.sltdTPIndex];
    const radian = this.pointRefRadians[this.sltdTPIndex] + v / 100 * (Math.PI / 3);
    this.setRadian([{ pTag: tangentPoint.tag, radian }], true)
  }

  moveAllPoints(v: number) {
    const pointInfoArr = [...this.getRedPoints()].map((p, pI) => {
      const radian = this.pointRefRadians[pI] + v / 100 * (Math.PI / 3);
      return { pTag: p.tag, radian };
    })
    this.setRadian(pointInfoArr, true);
  }
  setCoord() {
    this.setTangentCoords();
    this._setCoord();
  }
}